<script>
  import Modal from '../Modal.svelte';
  import LinkButton from '../../components/LinkButton.svelte';

  export let link = '/products/sports/';
  export let allowModal = true;
  export let isSublimationProduct = false;

  const features = [
    {
      img: 'shirt.svg',
      label: 'Design Online',
      description: 'Make it your own! Add logos, names, numbers.',
      extendedDescription:
        'Make it your own! Add logos, names, numbers. Design online or upload your own artwork. We have a huge range of fonts and colours to choose from. craft the jersey of your dreams. No rules, just pure creativity! Need help? Our team of designers are here to assist.',
    },
    isSublimationProduct
      ? {
          img: 'shipped.svg',
          label: '3-Week Fast Delivery',
          description: 'Rush production and express shipping options.',
          extendedDescription: `Need it fast? We have you covered! With our lightning-speed delivery, you'll be sporting your new look in just a few weeks. Faster than you can say 'Go Team! Select Rush Production and Express Shipping at checkout.`,
        }
      : {
          img: 'shipped.svg',
          label: '7-Day Fast Delivery',
          description: 'Rush production and express shipping options.',
          extendedDescription: `Need it fast? We have you covered! With our lightning-speed delivery, you'll be sporting your new look in just a week. Faster than you can say 'Go Team! Select Rush Production and Express Shipping at checkout.`,
        },
    {
      img: 'order.svg',
      label: 'No Minimums',
      description: '1 or 2 items? No minimums. No hassle.',
      extendedDescription: `1 or 2 items? No minimums. No hassle. Whether you're suiting up a squad or just yourself, we welcome all orders! Big or small, every design deserves to shine.`,
    },
    {
      img: 'australia.svg',
      label: 'AUS Ownded & Operated',
      description: 'AU owned & operated. Support local.',
      extendedDescription: `Australian owned & operated. All classic items are printed in-house. Proudly local, always awesome! We print right here in Australia, ensuring top-notch quality while supporting our home turf.`,
    },
  ];

  let showModal = false;
  let selectedFeature = features[0];

  const openModal = (item) => {
    selectedFeature = item;
    if (!allowModal) return;
    showModal = true;
  };

  const closeModal = () => {
    showModal = false;
  };
</script>

<Modal show={showModal} allowClose={true} closeFn={closeModal}>
  <h2 class="feature-heading">{selectedFeature.label}</h2>
  <p class="feature-text">{selectedFeature.extendedDescription}</p>
  <LinkButton to={link} label="Start Designing" type="orange" />
</Modal>

<div class="features">
  {#each features as item}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="item" on:click={() => openModal(item)}>
      <div class="img"><img src="img/icons/{item.img}" alt="" /></div>
      <div class="details">
        <div class="label">{item.label}</div>
        <div class="desc">
          {item.description}
        </div>
      </div>
    </div>
  {/each}
</div>

<style>
  .feature-heading {
    font-family: 'Oswald', sans-serif;
    font-size: 2.4rem;
    color: #fe5900;
    margin-bottom: 1rem;
  }

  .feature-text {
    font-weight: 400;
    font-size: 1.6rem;
    margin-bottom: 2rem;
  }
  .features {
    padding: 2rem 0rem;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
    gap: 2rem;
    max-width: 140rem;
    margin: 0 auto;
  }

  .item {
    display: flex;
    align-items: center;
    z-index: 5;
    box-shadow: #cfcdcd 0px -1px 6px 2px;
    padding: 0.6rem;
  }

  .item:hover {
    cursor: pointer;
    box-shadow: #858484 0px -1px 6px 2px;
  }

  .img {
    background-color: #1c2a5c;
    width: 6rem;
    height: 6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
  }

  .img img {
    width: 100%;
  }

  .details {
    padding-left: 1rem;
  }

  .label {
    font-family: 'Oswald', sans-serif;
    font-size: 1.8 rem;
    color: #fe5900;
  }

  .desc {
    font-weight: 400;
    font-size: 1.2rem;
  }

  @media screen and (min-width: 450px) {
    .img {
      width: 6rem;
      height: 6rem;
      padding: 1rem;
    }

    .label {
      font-size: 1.8rem;
    }
    .desc {
      font-size: 1.4rem;
    }
  }

  @media screen and (min-width: 600px) {
    .img {
      width: 7rem;
      height: 7rem;
      padding: 1rem;
    }

    .label {
      font-size: 1.8rem;
    }
    .desc {
      font-size: 1.2rem;
    }
  }

  @media screen and (min-width: 900px) {
    .features {
      width: 90%;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 4rem;
    }

    .img {
      width: 6rem;
      height: 6rem;
      padding: 1rem;
    }

    .label {
      font-size: 2rem;
    }
    .desc {
      font-size: 1.2rem;
    }
  }

  @media screen and (min-width: 1000px) {
    .img {
      width: 7rem;
      height: 7rem;
      padding: 1.5rem;
    }
    .features {
      gap: 5rem;
    }
  }

  @media screen and (min-width: 1100px) {
    .label {
      font-size: 2.2rem;
    }
    .desc {
      font-size: 1.4rem;
    }
  }
</style>
